'use client';

import {motion} from 'framer-motion';
import Link from 'next/link';
import {useEffect, useState, useRef} from 'react';
import Navigation from './Navigation/Navigation';
import headerVariants from 'animation/headerVariants';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menu = useRef(null);

  const closeMenu = () => {
    if (menu.current) {
      setMenuOpen(false);
    }
  };

  useEffect(() => {
    if (window) {
      const listener = window.addEventListener('resize', closeMenu);
      return () => window.removeEventListener('resize', listener);
    }
  }, []);

  const changeMenu = () => {
    setMenuOpen(() => !menuOpen);
  };

  return (
    <motion.header
      ref={menu}
      className={menuOpen ? 'header open' : 'header'}
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={headerVariants}
    >
      <div className='container' style={{position: 'relative'}}>
        <Link href='/' className='logo'/>
        <div className='navigation-container'>
          <Navigation closeMenu={closeMenu} />
        </div>
        <div className='buttons-container'>
          <Link href='/contact' className='btn request-btn'>
            Request Demo
          </Link>
          <button className='burger-btn' onClick={changeMenu}></button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;

